import { render, staticRenderFns } from "./EditorHeaderWrapper.vue?vue&type=template&id=32b0c548&scoped=true&"
import script from "./EditorHeaderWrapper.vue?vue&type=script&lang=js&"
export * from "./EditorHeaderWrapper.vue?vue&type=script&lang=js&"
import style0 from "./EditorHeaderWrapper.vue?vue&type=style&index=0&id=32b0c548&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b0c548",
  null
  
)

export default component.exports